import { getProductionV1Data } from 'services/productionV1';

export async function getApplicationStatus() {
  let response = '';
  let errorMessage = '';  
  try {
    response = await getProductionV1Data({
      url: '/applicationstatus',
      withAuth: true,
    });
  } catch (error) {
    errorMessage = error.message;
  }
  return { response, errorMessage };
}